<template>
  <div class="unfinish-notice-module">
    <div class="unfinish-notice">
      <div class="top">
        <i class="sprite-icon sprite-icon-home-logo" />
        <span>PDF</span>
        <img :src="require('./images/close-icon.png')" class="close" @click="handleClickClose(2)"/>
      </div>
      <div class="content">
        <div class="text">
          <img :src="require('./images/unfinish-icon.png')"/>
          <div class="desc">
            <p>您有订单待支付</p>
            <p>PDF会员含<em>PDF转换、PDF编辑、图片编辑</em>等权益！快立即抢购，享限时优惠</p>
          </div>
        </div>
        <div class="btn-group">
          <div class="btn pay-btn" @click="handleClickPay">立即支付</div>
          <div class="btn" @click="handleClickClose(3)">忽略</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setUnpaidGuideInfo } from '@/utils/sessionStorage'
import { UNFINISH_PAY_LIST } from '@/config/dataMap'
import client from '@/client'

export default {
  name: 'UnfinishNotice',
  methods: {
    handleClickClose (status) {
      this.infocReport({ tipsshow: 1, tipsclick: status })
      this.$emit('handleCloseUnfinishNotice', 0)
    },
    handleClickPay () {
      this.infocReport({ tipsshow: 1, tipsclick: 1 })
      this.$emit('handleCloseUnfinishNotice', 1)
    },
    infocReport (params) {
      try {
        client.activity.REPORT.reportUnpaidOperate(params)
      } catch (error) {
        console.error(' == 上报错误 == ', error)
      }
    }
  },
  mounted () {
    setUnpaidGuideInfo(UNFINISH_PAY_LIST.HAVE_OPEN_UNFINISH_MODULE)
    this.infocReport({ tipsshow: 1 })
  }
}
</script>

<style lang="scss" scoped>
.unfinish-notice-module {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);

  .unfinish-notice {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-45%, -50%);
    width: 420px;
    height: 180px;
    box-shadow: 0px 4px 10px 0px #00000033;
    background-color: #ffffff;
    text-align: left;

    .top {
      position: relative;
      display: flex;
      align-items: center;
      padding: 6px 0 8px 6px;
      height: 28px;
      box-sizing: border-box;
      background: url('./images/back-bg.png') no-repeat;
      background-size: 100% auto;

      span {
        margin-left: 4px;
        font-family: Microsoft YaHei;
        font-size: 12px;
        font-weight: 400;
        color: #B07400;

      }

      .close {
        position: absolute;
        top: 9.34px;
        right: 6.34px;
        width: 11.31px;
        cursor: pointer;
      }
    }
    .content {
      padding: 20px 20px 20px 16px;

      .text {
        display: flex;
        color: #888888;
        font-family: Microsoft YaHei;
        font-size: 14px;
        font-weight: 400;

        img {
          margin-top: 5px;
          margin-right: 16px;
          width: 48px;
          height: 48px;
        }

        p:nth-of-type(1) {
          font-size: 16px;
          font-weight: 600;
          color: #333333;
        }
        p:nth-of-type(2) {
          margin-top: 8px;
          
          em {
            font-style: normal;
            color: #FF0000;
          }
        }
      }
      .btn-group {
        display: flex;
        justify-content: flex-end;
        margin-top: 11px;

        .btn {
          width: 100px;
          height: 34px;
          color: #707070;
          background-color: #FFFFFF;
          border: 1px solid #CCCCCC;
          border-radius: 2px;
          text-align: center;
          line-height: 34px;
          font-size: 12px;
          cursor: pointer;
        }
        .pay-btn {
          margin-right: 10px;
          background: #63B422;
          border: unset;
          font-weight: 700;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>
